export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/5860effcda061f4f05feb4a92be5a34c.svg";